class ToggleMenuItem {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-scope="toggle"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click', (e) => {
			let $active = $(this.config.scope + '.active');
			$(e.currentTarget).toggleClass('active');
			$active.removeClass('active');
		});
	}
}

export default new ToggleMenuItem;